import type {
  PlaneBox,
  Position2D,
} from '@Components/BigBrowse/Model/ModelTypes';
import { Vector3 } from 'three';

export const rectanglesOverlap = (rect1: PlaneBox, rect2: PlaneBox) =>
  // see https://stackoverflow.com/questions/306316/determine-if-two-rectangles-overlap-each-other
  !(
    rect1.right < rect2.left ||
    rect1.left > rect2.right ||
    rect1.bottom > rect2.top ||
    rect1.top < rect2.bottom
  );

const getPositionFromBox = (cardBox: PlaneBox): Position2D => {
  const { left, right, top, bottom } = cardBox;

  return {
    x: (left + right) / 2,
    y: (top + bottom) / 2,
  };
};

/** Return dx,dy of an item to escape from screen moving away from its center */
export const getExplodingPositionDeltas = (
  cameraWindow: PlaneBox,
  itemBox: PlaneBox
): { dx: number; dy: number } => {
  const center = getPositionFromBox(cameraWindow);
  const centerV = new Vector3(center.x, center.y, 0);

  const distance =
    Math.max(
      cameraWindow.right - cameraWindow.left,
      cameraWindow.top - cameraWindow.bottom
    ) / 1.75;

  const itemPos = getPositionFromBox(itemBox!);
  const itemV = new Vector3(itemPos.x, itemPos.y, 0);

  const direction = new Vector3().subVectors(itemV, centerV).normalize();
  const targetV = new Vector3()
    .copy(itemV)
    .addScaledVector(direction, distance);

  const dx = targetV.x - itemV.x;
  const dy = targetV.y - itemV.y;

  return { dx, dy };
};

export const getImageSizeFromUrl = (imageUrl?: string): number => {
  if (!imageUrl) {
    return 0;
  }

  const parsed = imageUrl.split('/');
  return Number(parsed[5]) || 400;
};

export const getPossibleBodyHeight = (text?: string, titleText?: string) => {
  if (!text || !titleText) {
    return 0;
  }
  const height = titleText.length > 23 ? 20 : 0;
  const displayable = sliceText(text, 200);
  const textLength = displayable.length;
  if (textLength < 70) {
    return height + 40;
  }
  if (textLength < 140) {
    return height + 60;
  }
  if (textLength < 170) {
    return height + 80;
  }
  return height + 100;
};

export const sliceText = (text: string | undefined, limit: number = 200) => {
  if (!text) {
    return '';
  }
  let total = '';
  const textArray = text.split('.');
  for (const str of textArray) {
    // if str is empty '.' might get added twice, so preventing this
    const body = total + str + (str ? '.' : '');
    if (body.length > limit) {
      return total;
    }
    total = body;
  }
  return total;
};
